import Axios from 'axios';
import Collection from '@/stores/abstract/Collection';
import Model from '@/stores/abstract/Model';
import axiosInstance from '@/helpers/axios';
import {generateLog, translate, translatedDisplayName} from '@/helpers/functions';
import {Vue} from 'vue-property-decorator';

const URL: string = '/dashboards';
const CancelToken: any = Axios.CancelToken;
let cancel: any;

export class Dashboards extends Model<IDashboards> implements IDashboards {
  deviceTypeId!: number;
  name!: string;
  type!: any;
  activePanel!: number;
  background!: number;
  redirectModuleId!: string;
  redirectLayout!: string;
  redirectAction!: string;
  redirectElementId!: string;
  active!: boolean;
  id!: number | null;
  panels!: IPanel[];
  qr!: IQRMapper;

  constructor(attributes: any = {}, parentCollection?: any) {
    super(
      {
        ...{
          id: null,
          deviceTypeId: null,
          name: '',
          type: '',
          activePanel: null,
          background: null,
          active: false,
          redirectModuleId: '',
          redirectLayout: '',
          redirectAction: '',
          redirectElementId: '',
          panels: [],
        }, ...attributes,
      }, // Default values
      parentCollection,
    );
  }

  urlRoot(): string {
    return URL;
  }
}

// Class for all dashboard, Panel and its element operations
export default class DashboardsCollection extends Collection<Dashboards> {
  type = 'STB';
  routeName = 'stbDashboards';

  model(): Constructor<Dashboards> {
    return Dashboards;
  }

  // url for dashboard operations
  url(): string {
    return URL;
  }

  composerUrl(): string {
    return '/composer/stb';
  }

  elementUrl(): string {
    return '';
  }

  fetchData(index: number = 1, search: string | null, perpage: number | null, type = 'STB') {
    if (cancel !== undefined) {
      cancel();
    }

    if (search) {
      return axiosInstance.get(`${this.url()}?type=${type}&search=${search}&page=${index}&perpage=${perpage}`, {
        cancelToken: new CancelToken(function executor(c: any) {
          cancel = c;
        }),
      })
        .then((response) => response.data).catch((e) => {
          const log: any = {
            route: 'STB',
            message: e,
          };
          generateLog(log);
        });
    } else {
      return axiosInstance.get(`${this.url()}?type=${type}&page=${index}&perpage=${perpage}`, {
        cancelToken: new CancelToken(function executor(c: any) {
          cancel = c;
        }),
      })
        .then((response) => response.data).catch((e) => {
          const log: any = {
            route: 'STB',
            message: e,
          };
          generateLog(log);
        });
    }
  }

  /*
   * Dashboard panel operation area start
   */
  getDashboard(id: any) {
    return axiosInstance.get(`${this.composerUrl()}/${id}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'STB',
          message: e,
        };
        generateLog(log);
      });
  }

  createNewItem(newDashboard: IDashboards) {
    newDashboard.type = 'STB';
    return axiosInstance.post(`${this.url()}`, newDashboard)
      .then((response) => {
        return response.data;
      }).catch((e) => {
        const log: any = {
          route: 'STB',
          message: e,
        };
        generateLog(log);
      });
  }

  deleteItem(id: string) {
    return axiosInstance.delete(`${this.url()}/${id}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'STB',
          message: e,
        };
        generateLog(log);
      });
  }

  deleteItems(ids: any[]) {
    return axiosInstance.post(`${this.url()}/delete`, {ids})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'STB',
          message: e,
        };
        generateLog(log);
        return e.response.data;
      });
  }

  updateItem(dashboardId: any, data: any) {
    return axiosInstance.put(`${this.composerUrl()}/${dashboardId}`, data)
      .then((response: any) => {
        return response.data;

      }).catch((e: any) => {
        const log: any = {
          route: 'STB',
          message: e,
        };
        generateLog(log);
      });
  }

  create(data: any) {
    return axiosInstance.post(`${this.composerUrl()}`, data)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'STB',
          message: e,
        };
        generateLog(log);
      });
  }
  createCopyExistingDashboard(dashboardId: any, newDashboard: IDashboards) {
    newDashboard.type = 'STB';
    console.log(newDashboard, dashboardId);
    return axiosInstance.post(`${this.url()}/copy/existing/${dashboardId}`, newDashboard)
      .then((response) => {
        return response.data;
      }).catch((e) => {
        const log: any = {
          route: 'Mobile',
          message: e,
        };
        generateLog(log);
      });
  }

  vodCategories(moduleId: any) {
    return axiosInstance.get(`vod/${moduleId}/categories`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'STB',
          message: e,
        };
        generateLog(log);
      });
  }

  vodCategory(moduleId: any, categoryId: any) {
    return axiosInstance.get(`vod/${moduleId}/categories/${categoryId}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'STB',
          message: e,
        };
        generateLog(log);
      });
  }

  tvCategories(moduleId: any) {
    return axiosInstance.get(`tv/${moduleId}/categories`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'STB',
          message: e,
        };
        generateLog(log);
      });
  }

  tvCategory(moduleId: any, categoryId: any) {
    return axiosInstance.get(`tv/${moduleId}/categories/${categoryId}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'STB',
          message: e,
        };
        generateLog(log);
      });
  }

  CatalogueCategories(moduleId: any) {
    return axiosInstance.get(`pages/${moduleId}/categories`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'STB',
          message: e,
        };
        generateLog(log);
      });
  }

  CatalogueCategory(moduleId: any, categoryId: any) {
    return axiosInstance.get(`pages/${moduleId}/categories/${categoryId}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: 'STB',
          message: e,
        };
        generateLog(log);
      });
  }

  duplicateItem(id: number | string) {
    const currentDashboardName: string = Vue.prototype.translate(`dashboards.${id}.name`);
    const newDashboradName: string = currentDashboardName + ' (copy)';
    const newDashboard: any = {
      id: null,
      name: newDashboradName,
      active: true,
      type: 'STB'
    };

    return axiosInstance.post(`${this.url()}/copy/existing/${id}`, newDashboard)
      .then((response) => {
        return response.data;
      }).catch((e) => {
        const log: any = {
          route: 'STB',
          message: e,
        };
        generateLog(log);
      });
  }

}
